<template>
  <div
    class="bg-gray-50 flex items-center justify-center px-4"
    :class="isAddMode ? 'fixed inset-0 z-50 overflow-y-auto py-8' : 'min-h-screen'"
  >
    <div class="max-w-md w-full">
      <div class="bg-white rounded-lg shadow-sm p-8">
        <div class="text-center">
          <h1 class="text-3xl font-bold text-gray-900 mb-2">
            {{ isAddMode ? 'Add another account' : 'WrestlingIQ Kiosk' }}
          </h1>
          <p class="text-gray-600 mb-6">
            Enter {{ isAddMode ? 'a' : 'your' }} 6-digit kiosk code
          </p>

          <div class="space-y-4">
            <input
              v-model="kioskCode"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center text-lg"
              placeholder="6-digit Kiosk Code"
              required="required"
              type="text"
              name="kiosk-code"
              autocapitalize="off"
              autocomplete="off"
              autocorrect="off"
              spellcheck="false"
              @keyup.enter="authenticate"
            />

            <button
              @click="authenticate"
              :disabled="loading || !kioskCode"
              class="w-full px-6 py-3 bg-wiq-green text-white font-semibold rounded-lg hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition"
            >
              <span v-if="loading" class="flex items-center justify-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Authenticating...
              </span>
              <span v-else>{{ isAddMode ? 'Add Account' : 'Use Kiosk' }}</span>
            </button>

            <button
              v-if="isAddMode"
              @click="$emit('cancel')"
              :disabled="loading"
              class="w-full px-6 py-3 border border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition"
            >
              Cancel
            </button>

            <p v-if="error" class="text-red-600 text-sm mt-4">
              {{ errorMessage }}
            </p>
          </div>

          <template v-if="!isAddMode">
            <hr class="my-8 border-gray-200" />

            <div class="text-center">
              <p class="text-gray-900 font-semibold text-lg mb-2">Need a kiosk code?</p>
              <p class="text-gray-600 mb-4">
                Scan below or visit<br />
                <a href="https://www.wrestlingiq.com/kiosk_tokens" target="_blank" rel="noopener" class="text-blue-600 hover:underline font-medium">wrestlingiq.com/kiosk_tokens</a>
              </p>
              <img
                src="https://mktg-cdn.wrestlingiq.com/qr/kiosk_tokens_qr_code.png"
                alt="Scan to create a kiosk code"
                class="mx-auto"
                style="max-width: 140px;"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceSetup',
  props: {
    store: {
      type: Object,
      required: true,
    },
    // 'initial' for first-time device setup, 'add' for adding another club to a set-up device
    mode: {
      type: String,
      default: 'initial',
      validator: (value) => ['initial', 'add'].includes(value),
    },
  },
  emits: ['authenticated', 'cancel'],
  data() {
    return {
      loading: false,
      error: false,
      errorMessage: '',
      kioskCode: '',
    };
  },
  computed: {
    isAddMode() {
      return this.mode === 'add';
    },
  },
  methods: {
    authenticate() {
      if (!this.kioskCode || this.loading) return;

      const vm = this;
      vm.loading = true;
      vm.error = false;
      const url = vm.$apiService.kioskSessionUrl();
      const params = {
        kiosk: {
          token: vm.kioskCode,
        },
      };
      axios.post(url, params)
        .then((response) => {
          // Upserts by kiosk id, so re-entering a saved club's code just switches to it
          vm.store.setActiveKiosk(response.data.kiosk);
          if (vm.isAddMode) {
            // Full reload so nothing from the previous club carries over
            window.location.reload();
            return;
          }
          vm.loading = false;
          vm.$emit('authenticated');
        })
        .catch((error) => {
          vm.loading = false;
          vm.errorMessage = 'Failed to setup kiosk. Please double check your Kiosk code or contact support@wrestlingiq.com';
          vm.error = true;
        });
    },
  },
};
</script>
